module.exports = __webpack_public_path__ + "img/1zl@2x.30aa8c71.png";